export default "__VITE_ASSET__90574ff0__"